import React from "react";
import styles from "./Navbar.css";
import config from "../../../resources/config";
import events from "../../events";

const Logo = require("./images/ic-cobli.svg");

interface Props {
  fleetName: string;
  fleetLogoUrl?: string;
}

export const Navbar = ({ fleetName, fleetLogoUrl }: Props) => (
  <div className={fleetLogoUrl ? styles.navbar_with_logo : styles.navbar}>
    {fleetLogoUrl ? (
      <img src={fleetLogoUrl} className={styles.navbar_client_logo} />
    ) : (
      <p className={styles.navbar_fleet_text}>{fleetName}</p>
    )}
    <div className={styles.cobliText}>
      <p className={styles.navbar_cta_text}>Rastreado por</p>

      <div className={styles.navbar_cta}>
        <a
          className={styles.navbar_logo_link}
          href={config.landingPageUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => events.lead.navbarLogo(fleetName)}
        >
          <Logo className={styles.navbar_logo} />
        </a>
      </div>
    </div>
  </div>
);
